import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuthContext } from "./context/providers/AuthContext";
import Navigation from "./components/Navigation/Navigation";
import Footer from "./components/Footer/Footer";


const PrivateRoute = ({ component: Component, ...rest }) => {
	const { isAuthenticated, userAuthenticated, token } = useAuthContext();

	return (
		<Route
			{...rest}
			render={(props) =>
				!isAuthenticated && !userAuthenticated && !token ? (
					<Redirect to="/auth" />
				) : (
					<>
						<Navigation {...props}></Navigation>
						
							<Component {...props} />
					
						<Footer></Footer>
					</>
				)
			}
		/>
	);
};

export default PrivateRoute;
